<hr>

<style>
    hr {
        border: none;
        height: 1px;
        background-color: var(--background-offset);
        margin: 4rem 0;
    }
</style>
    